class Api {
    constructor() { }

    call(requestType, url, data = null) {
        return new Promise((resolve, reject) => {
            this.$axios[requestType](url, data)
                .then(response => {
                    resolve(response);
                })
                .catch(({ response }) => {
                    if (response.status === 401) {
                        this.$auth.logout();
                    }

                    reject(response);
                });
        });
    }
}

export default Api;